export const SCOPE_CODE = {
  platform: 'platform',
  tenant: 'tenant',
  client: 'client',
} as const;

export type ScopeCode = (typeof SCOPE_CODE)[keyof typeof SCOPE_CODE];

export const PLATFORM_SCOPE_CODE: ScopeCode = SCOPE_CODE.platform;

export const PLATFORM_WORKSPACE_SELECTION = 'platform';

export const SELECTABLE_SCOPE_CODES: ScopeCode[] = [
  SCOPE_CODE.platform,
  SCOPE_CODE.tenant,
  SCOPE_CODE.client,
];
